import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"list-bug"},"children":[{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M4.83231 6.96891V7.81833C4.83231 8.6005 5.70253 9.90958 6.83261 9.90941C7.96253 9.90924 8.8323 8.6005 8.8323 7.81833V6.96891V6.36809C8.81999 5.10241 8.08324 3.86688 6.83261 3.8667C5.58182 3.86651 4.8265 5.24735 4.83231 6.36809V6.96891Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M15 5H21M21 9.99988H15M3 15H21M3 20H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M4.83246 6.96912H2.83259M4.83246 6.96912V7.81854C4.83246 8.60071 5.70268 9.90979 6.83276 9.90962C7.96268 9.90945 8.83245 8.60071 8.83245 7.81854C8.83245 7.03637 8.83245 6.96912 8.83245 6.96912M4.83246 6.96912V6.3683C4.82665 5.24756 5.58197 3.86673 6.83276 3.86691C8.08339 3.8671 8.82014 5.10262 8.83245 6.3683V6.96912M10.8324 6.96914L8.83245 6.96912M4.36067 9.3672L2.83254 9.93161L2.83253 10.8186M9.30413 9.3672L10.8324 9.90962L10.8324 10.7966M4.36046 4.87018L2.89951 4.44596V3.33132M9.30413 4.86987L10.8324 4.44567V3.33102","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const ListBug = Vue.extend<IconProps>({
  name: 'ListBugIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'list-bug',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default ListBug;
